export default __webpack_public_path__ + "static/media/bg-landingpage-1.34e13e49.png";